import { formatDateToTimezone, ShortDateFormat } from '@utils/date';
import { TransactionType } from '@models/policyTransaction';
import { InternalQuoteStatus } from '@models/quotes';
import { PolicyStatusText } from '@models/policy';

export const formatEffectiveDate = (date: string | Date | undefined): string => {
  if (!date) return '';
  return formatDateToTimezone(date, ShortDateFormat);
};

export const getTransactionTypeLabel = (transactionType: string): string => {
  return TransactionType[transactionType] || transactionType;
};

export const getQuoteStatusLabel = (statusId: string): string => {
  return InternalQuoteStatus[statusId] || statusId;
};

export const getPolicyStatusLabel = (status: string): string => {
  return PolicyStatusText[status] || status;
};
